export const relationStrengthTranslations = {
  LOW: 'Laag',
  MEDIUM: 'Normaal',
  HIGH: 'Hoog',
};

export const relationStrengths = [
  { key: 'LOW', label: 'Laag' },
  { key: 'MEDIUM', label: 'Normaal' },
  { key: 'HIGH', label: 'Hoog' },
];
